import { MonthlyPrayerTimes } from '../types';

export const augustPrayerTimes: MonthlyPrayerTimes = {
  1: {
    fajr: "03:00",
    shoruk: "04:26",
    dhuhr: "12:59",
    asr: "17:19",
    maghrib: "21:22",
    isha: "22:39"
  },
  2: {
    fajr: "03:02",
    shoruk: "04:28",
    dhuhr: "12:59",
    asr: "17:18",
    maghrib: "21:20",
    isha: "22:37"
  },
  3: {
    fajr: "03:03",
    shoruk: "04:31",
    dhuhr: "12:59",
    asr: "17:17",
    maghrib: "21:18",
    isha: "22:35"
  },
  4: {
    fajr: "03:04",
    shoruk: "04:33",
    dhuhr: "12:59",
    asr: "17:16",
    maghrib: "21:15",
    isha: "22:33"
  },
  5: {
    fajr: "03:06",
    shoruk: "04:35",
    dhuhr: "12:59",
    asr: "17:15",
    maghrib: "21:13",
    isha: "22:31"
  },
  6: {
    fajr: "03:07",
    shoruk: "04:37",
    dhuhr: "12:59",
    asr: "17:13",
    maghrib: "21:10",
    isha: "22:29"
  },
  7: {
    fajr: "03:08",
    shoruk: "04:40",
    dhuhr: "12:59",
    asr: "17:12",
    maghrib: "21:08",
    isha: "22:29"
  },
  8: {
    fajr: "03:09",
    shoruk: "04:42",
    dhuhr: "12:59",
    asr: "17:11",
    maghrib: "21:05",
    isha: "22:27"
  },
  9: {
    fajr: "03:11",
    shoruk: "04:44",
    dhuhr: "12:58",
    asr: "17:10",
    maghrib: "21:03",
    isha: "22:26"
  },
  10: {
    fajr: "03:12",
    shoruk: "04:47",
    dhuhr: "12:58",
    asr: "17:09",
    maghrib: "21:00",
    isha: "22:24"
  },
  11: {
    fajr: "03:13",
    shoruk: "04:49",
    dhuhr: "12:58",
    asr: "17:07",
    maghrib: "20:57",
    isha: "22:22"
  },
  12: {
    fajr: "03:15",
    shoruk: "04:51",
    dhuhr: "12:58",
    asr: "17:06",
    maghrib: "20:55",
    isha: "22:20"
  },
  13: {
    fajr: "03:16",
    shoruk: "04:54",
    dhuhr: "12:58",
    asr: "17:05",
    maghrib: "20:52",
    isha: "22:19"
  },
  14: {
    fajr: "03:17",
    shoruk: "04:56",
    dhuhr: "12:58",
    asr: "17:03",
    maghrib: "20:49",
    isha: "22:17"
  },
  15: {
    fajr: "03:19",
    shoruk: "04:58",
    dhuhr: "12:57",
    asr: "17:02",
    maghrib: "20:47",
    isha: "22:15"
  },
  16: {
    fajr: "03:20",
    shoruk: "05:01",
    dhuhr: "12:57",
    asr: "17:01",
    maghrib: "20:44",
    isha: "22:13"
  },
  17: {
    fajr: "03:21",
    shoruk: "05:03",
    dhuhr: "12:57",
    asr: "16:59",
    maghrib: "20:41",
    isha: "22:11"
  },
  18: {
    fajr: "03:23",
    shoruk: "05:05",
    dhuhr: "12:57",
    asr: "16:58",
    maghrib: "20:38",
    isha: "22:10"
  },
  19: {
    fajr: "03:24",
    shoruk: "05:08",
    dhuhr: "12:57",
    asr: "16:56",
    maghrib: "20:36",
    isha: "22:08"
  },
  20: {
    fajr: "03:25",
    shoruk: "05:10",
    dhuhr: "12:56",
    asr: "16:55",
    maghrib: "20:33",
    isha: "22:07"
  },
  21: {
    fajr: "03:25",
    shoruk: "05:12",
    dhuhr: "12:56",
    asr: "16:53",
    maghrib: "20:30",
    isha: "22:06"
  },
  22: {
    fajr: "03:26",
    shoruk: "05:14",
    dhuhr: "12:56",
    asr: "16:52",
    maghrib: "20:27",
    isha: "22:05"
  },
  23: {
    fajr: "03:27",
    shoruk: "05:17",
    dhuhr: "12:56",
    asr: "16:50",
    maghrib: "20:24",
    isha: "22:04"
  },
  24: {
    fajr: "03:28",
    shoruk: "05:19",
    dhuhr: "12:55",
    asr: "16:48",
    maghrib: "20:22",
    isha: "22:03"
  },
  25: {
    fajr: "03:28",
    shoruk: "05:21",
    dhuhr: "12:55",
    asr: "16:47",
    maghrib: "20:19",
    isha: "22:01"
  },
  26: {
    fajr: "03:29",
    shoruk: "05:24",
    dhuhr: "12:55",
    asr: "16:45",
    maghrib: "20:16",
    isha: "22:00"
  },
  27: {
    fajr: "03:30",
    shoruk: "05:26",
    dhuhr: "12:54",
    asr: "16:44",
    maghrib: "20:13",
    isha: "21:59"
  },
  28: {
    fajr: "03:31",
    shoruk: "05:28",
    dhuhr: "12:54",
    asr: "16:42",
    maghrib: "20:10",
    isha: "21:58"
  },
  29: {
    fajr: "03:32",
    shoruk: "05:31",
    dhuhr: "12:54",
    asr: "16:40",
    maghrib: "20:07",
    isha: "21:57"
  },
  30: {
    fajr: "03:32",
    shoruk: "05:33",
    dhuhr: "12:54",
    asr: "16:38",
    maghrib: "20:04",
    isha: "21:56"
  },
  31: {
    fajr: "03:33",
    shoruk: "05:35",
    dhuhr: "12:53",
    asr: "16:37",
    maghrib: "20:01",
    isha: "21:55"
  }
};